module.exports = __webpack_public_path__ + "img/blue1.eb71d342.gif";